module.exports = [
  require('./yeth_hound'),
  require('./yuan_ti_anathema'),
  require('./yuan_ti_broodguard'),
  require('./yuan_ti_mind_whisperer'),
  require('./yuan_ti_nightmare_speaker'),
  require('./yuan_ti_pit_master'),
]
